import React from 'react';
import { TableV2, Content, Pane } from '@leverege/ui-elements';
import { ColumnRendererFactory, Attributes } from '@leverege/ui-attributes';
import { Toolbar } from '@leverege/ui-plugin';
import { ValueCache } from '@leverege/value-cache';
import classnames from 'classnames';
import Pagination from "../pagination/Pagination.js";
import Columns from "./Columns.js";
import UseSort from "./UseSort.js";
import UseSelect from "./UseSelect.js";
import UseRowProps from "./UseRowProps.js";
import RsrcModel from "../../models/Rsrc.js";
import S from './RsrcTable.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TYPE = 'rsrc.listRenderer.table';
const matchContext = {
  client: TYPE,
  objectType: RsrcModel.TYPE
};
class RsrcTable extends React.Component {
  constructor(props) {
    super(props);
    this.columnCache = new ValueCache();
    this.sortHookCache = new ValueCache();
    this.afterHooksCache = new ValueCache();
    this.tableInstancePropsCache = new ValueCache();
    this.contextCache = new ValueCache();
  }
  getColumns = objectType => {
    if (Columns) {
      return Columns.reduce((prev, curr) => {
        const rnd = ColumnRendererFactory.create(curr);
        if (rnd != null) {
          const colInfo = rnd.getColumnInfo({});
          const attribute = Attributes.getAttribute(curr.attrName, objectType);
          if (attribute) {
            colInfo.Filter = null; // renderFilter( curr, attribute )
            colInfo.attribute = attribute;
            prev.push(colInfo);
          }
        }
        return prev;
      }, []);
    }
    return [];
  };
  getSortHook = (filterModel, objectType, onFilterModelChange) => {
    return UseSort.create({
      filterModel,
      objectType,
      onFilterModelChange
    });
  };
  getAfterHooks = (useSort, useSelect, useRowProps) => {
    return [useSort, useSelect, useRowProps];
  };
  getTableInstanceProps = (rollover, selection, targeted, context) => {
    return {
      rollover,
      selection,
      targeted,
      context
    };
  };
  getContext = (props, columns) => {
    const {
      targeted
    } = this.props;
    return {
      clientProps: props,
      columns,
      target: targeted?.items
    };
  };
  render() {
    const {
      objectType = 'rsrc',
      variant = 'dataTable',
      filterModel,
      paginator,
      onFilterModelChange,
      rollover,
      selection,
      targeted,
      loading
    } = this.props;
    const columns = this.columnCache.calc(this.getColumns, objectType);
    const useSort = this.sortHookCache.calc(this.getSortHook, filterModel, objectType, onFilterModelChange);
    const afterHooks = this.afterHooksCache.calc(this.getAfterHooks, useSort, UseSelect, UseRowProps);
    const context = this.contextCache.calc(this.getContext, this.props, columns);
    const tableInstanceProps = this.tableInstancePropsCache.calc(this.getTableInstanceProps, rollover, selection, targeted, context);
    const fData = paginator?.pageItems?.filter(r => !!r);
    return /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsxs(Pane, {
          layout: "flex:rowSpaceBetween",
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            prefer: "icon",
            hasContextMenu: true,
            contextMenuHideWhenEmpty: true,
            matchContext: {
              ...matchContext,
              use: 'actionBarLeft'
            },
            context: context
          }), /*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            prefer: "icon",
            matchContext: {
              ...matchContext,
              use: 'actionBarRight'
            },
            context: context
          })]
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsx(TableV2, {
          type: "virtualized",
          noDataMessage: "No Data",
          className: classnames(S.table, loading ? S.loading : ''),
          variant: variant,
          loading: loading,
          loadingMessage: "Loading...",
          data: fData || [],
          columns: columns,
          afterHooks: afterHooks,
          paginate: false,
          tableInstanceProps: tableInstanceProps
        })
      }), /*#__PURE__*/_jsx(Content.Footer, {
        children: /*#__PURE__*/_jsx(Pagination, {
          paginator: paginator,
          matchContext: matchContext,
          context: context
        })
      })]
    });
  }
}
RsrcTable.TYPE = TYPE;
RsrcTable.PLUGIN = {
  type: TYPE,
  component: RsrcTable
};
export default RsrcTable;